import { GET_BILLING_INFO } from "./billing-info.constant";

const initialState = {
  info: null,
  fees: [],
  loading: false,
  error: null,
};

export const billingInfoReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case GET_BILLING_INFO.START:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLING_INFO.SUCCESS:
      return {
        ...state,
        info: payload[0],
        fees: payload[1],
        loading: false,
      };
    default:
      return state;
  }
};
